import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import FilePresentIcon from '@mui/icons-material/FilePresent';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import GroupsIcon from '@mui/icons-material/Groups';
import EventIcon from '@mui/icons-material/Event';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import DomainIcon from '@mui/icons-material/Domain';
import {Link, useNavigate, useParams} from "react-router-dom";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import {connect} from "react-redux";
import {getUserInfo} from "../store/logIn";

function Main(props) {
    const {t, i18n} = useTranslation()
    const navigate = useNavigate()
    const params = useParams()
    const [regionId, setRegionId] = useState(false)
    const [isOther, setIsOther] = useState(false)

    useEffect(()=>{
        props.getUserInfo()
    }, [])

    useEffect(()=>{
        setRegionId(params.id)
    }, [params.id])

    useEffect(()=>{
        if(props.user) {
            setIsOther(props.user.is_other)
        }
    }, [props.user])

    const toBack = () => {
        navigate(-1);
    }

    // viloyat kabinetida (is_other=true va params.id yo'q) - "Mening bo'limim" va "Tuman/shahar bo'limlari"
    // markaziy bo'lim tomonidan viloyatga kirgan (params.id bor) - oddiy ko'rinish
    const isRegionOwnCabinet = isOther && !regionId

    return (
        <div className="App">
            <div className={'home page'}>
                <Header/>
                <Dashboard/>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                    }}>
                    <Toolbar/>
                    <div className={'main'}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon />} onClick={toBack}>
                            {t('back')}
                        </Button>

                        {isRegionOwnCabinet ? (
                            // Viloyat o'z kabinetida: "Mening bo'limim" va "Tuman/shahar bo'limlari"
                            <div className="row">
                                <div className="col-lg-3">
                                    <Link to={'/my-department/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <DomainIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('my_department')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-lg-3">
                                    <Link to={'/my-districts/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <LocationCityIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('district_branches')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        ) : (
                            // Markaziy bo'lim viloyatga kirgan yoki boshqa holat
                            <div className="row">
                                <div className="col-lg-3">
                                    <Link to={regionId ? '/documents/'+regionId : '/documents/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <FilePresentIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('required_documents')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-lg-3">
                                    <Link to={regionId ? '/problems/'+regionId : '/problems/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <SyncProblemIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('problems')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-lg-3">
                                    <Link to={regionId ? '/workers/'+regionId : '/workers/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <FolderSharedIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('list_employees')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-lg-3">
                                    <Link to={regionId ? '/members/'+regionId : '/members/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <GroupsIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('members')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-lg-3">
                                    <Link to={regionId ? '/stats/'+regionId : '/stats/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <QueryStatsIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('stats')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-lg-3">
                                    <Link to={regionId ? '/events/'+regionId : '/events/'}>
                                        <div className="card">
                                            <div className="card-header">
                                                <EventIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{t('events')}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                {regionId && (
                                    <div className="col-lg-3">
                                        <Link to={'/region-districts/'+regionId}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <LocationCityIcon className={'icon-card'}/>
                                                </div>
                                                <div className="card-body">
                                                    <h3 className={'text-center mb-0 text-uppercase'}>{t('district_branches')}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    );
}

export default connect(props => props.login, {getUserInfo})(Main);
